"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _propTypes = require("prop-types");
var _DatePicker = _interopRequireDefault(require("./DatePicker"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _WeekDayFilter = _interopRequireWildcard(require("../WeekDayFilter"));
var _TimeFilter = _interopRequireWildcard(require("../TimeFilter"));
var _FilterButton = _interopRequireDefault(require("./FilterButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FiltersToolbar = _ref => {
  var _context, _context2;
  let {
    filterBy,
    onDayOfWeekChange,
    onTimeOfDayChange,
    onDateChange,
    onClose,
    selectedDate,
    intl,
    track
  } = _ref;
  // sorted selected days
  const dayFilterVal = (0, _filter.default)(_context = (0, _reduce.default)(_context2 = [...filterBy.dayOfWeek]).call(_context2, (acc, dayIndex) => {
    acc[dayIndex] = _WeekDayFilter.DAYS_OF_WEEK[dayIndex];
    return acc;
  }, [])).call(_context, Boolean);
  const timeFilterVal = filterBy.timeOfDay.size === 0 || filterBy.timeOfDay.has(_TimeFilter.TIME_OF_DAY.ALL) ? _TimeFilter.TIME_OF_DAY.ALL : [...filterBy.timeOfDay].join(', ');
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "ApptList__JumpToDate"
  }, /*#__PURE__*/_react.default.createElement(_styles.MobileWrapper, null, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
    date: selectedDate,
    onDateChange: onDateChange,
    onClose: onClose
  }), /*#__PURE__*/_react.default.createElement(_styles.DayTimeFiltersWrapper, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterBy, FormattedMessage => /*#__PURE__*/_react.default.createElement(_styles.FilterByMessage, {
    className: "FilterByMessage"
  }, FormattedMessage)), /*#__PURE__*/_react.default.createElement(_FilterButton.default, {
    dataTestId: "ApptList__JumpToDate-DayOfWeek",
    active: dayFilterVal.length !== 0,
    btnAriaLabel: intl.formatMessage(_messages.default.ariaJumpToDateFilterDayOfWeekButton),
    btnText: dayFilterVal.length ? (0, _map.default)(dayFilterVal).call(dayFilterVal, item => (0, _slice.default)(item).call(item, 0, 3)).join(', ') : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterDayOfWeek),
    popoverDirection: "left",
    onOpen: () => {
      track('user_action.direct_book.jump_to_date.day_of_week');
    }
  }, /*#__PURE__*/_react.default.createElement(_WeekDayFilter.default, {
    filterBy: filterBy,
    onChange: onDayOfWeekChange
  })), /*#__PURE__*/_react.default.createElement(_FilterButton.default, {
    dataTestId: "ApptList__JumpToDate-TimeOfDay",
    active: timeFilterVal !== _TimeFilter.TIME_OF_DAY.ALL,
    btnAriaLabel: intl.formatMessage(_messages.default.ariaJumpToDateFilterTimeOfDayButton),
    btnText: timeFilterVal !== _TimeFilter.TIME_OF_DAY.ALL ? timeFilterVal : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterTimeOfDay),
    popoverDirection: "right",
    onOpen: () => {
      track('user_action.direct_book.jump_to_date.time_of_day');
    }
  }, /*#__PURE__*/_react.default.createElement(_TimeFilter.default, {
    filterBy: filterBy,
    onChange: onTimeOfDayChange
  })))));
};
FiltersToolbar.defaultProps = {
  selectedDate: ''
};
FiltersToolbar.propTypes = {
  selectedDate: _propTypes.string,
  onDateChange: _propTypes.func.isRequired,
  onClose: _propTypes.func,
  onDayOfWeekChange: _propTypes.func.isRequired,
  onTimeOfDayChange: _propTypes.func.isRequired,
  filterBy: _propTypes.object.isRequired,
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  }).isRequired,
  track: _propTypes.func
};
var _default = exports.default = (0, _intl.injectIntl)(FiltersToolbar);
FiltersToolbar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FiltersToolbar",
  "props": {
    "selectedDate": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onDateChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onClose": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onDayOfWeekChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onTimeOfDayChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "filterBy": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};